import getNoCategoryDishes from "./getNoCategoryDishes";
/**
 *
 * @param {Object} payload payload
 * @param {Object} payload.question menu insight question
 * @param {Array} payload.products products currently available
 *
 * @returns {Array} array of 'dishes' based on major group
 *
 */

function getMajorGroupDishes(_ref) {
  var question = _ref.question,
      products = _ref.products;
  var majorGroupRef = question === null || question === void 0 ? void 0 : question.menuMajorGroupRef;

  if (!majorGroupRef || !products) {
    return [];
  }

  return getNoCategoryDishes({
    question: question,
    products: products[majorGroupRef]
  });
}

export default getMajorGroupDishes;